<template>
  <div class="forwardingReport" ref="body">
    <div class="hierarchy">
      <div class="dataTitle">
        <van-icon class="hospiyalsArrowLeft" style="top: 16px;" name="arrow-left" @click="onBack" />
        <div class="title">
          <div class="content" @click="toReport" v-if="examReport">检查报告</div>
          <div class="line" v-if="examReport">|</div>
          <div class="content" @click="toPortrait">数字影像</div>
          <div class="line" v-if="reportInfoData[0].institution_id !== '06300007'">|</div>
          <div class="content" v-if="reportInfoData[0].institution_id !== '06300007'" @click="toAttachment">附件</div>
          <div class="line">|</div>
          <div class="content action">转发报告</div>
        </div>
      </div>
      <div>
        <div class="effectiveTime">
          <div class="forwardingVanDropdown">
            <van-cell class="effectiveVancell" title="有效时长" />
            <van-dropdown-menu class="effectiveVanDropdow">
              <van-dropdown-item v-model="value" :options="option1" @change="getMakeReportLink" />
            </van-dropdown-menu>
          </div>
        </div>
        <div class="effectiveContent">
          <div class="effectivePc">
            <div class="contentTitle">
              <div class="label"></div>
              <div class="value">转发电脑端用户方法</div>
              <div class="label"></div>
            </div>
            <div class="forwardingPC">
              <div>
                电脑浏览器输入网址
                <div id="copy-txt">{{forwardingData.url}}</div>
              </div>
              <!-- <div>对方输入访问密码,即可查看报告。</div> -->
              <van-checkbox-group v-model="encryptResult" @change="eventEncryptChange">
                <van-checkbox name="a" shape="square">加密（输入访问密码可以查看报告）</van-checkbox>
              </van-checkbox-group>
              <van-checkbox-group v-model="anonymousResult" @change="eventAnonymousChange">
                <van-checkbox name="b" shape="square">匿名化</van-checkbox>
              </van-checkbox-group>
              <van-checkbox-group v-model="waterMartResult" @change="eventWaterMartChange">
                <van-checkbox name="c" shape="square">报告水印（就诊人姓名水印）</van-checkbox>
              </van-checkbox-group>
              <van-button class="copyButton"  size="mini" @click="toCopy">复制</van-button>
            </div>
          </div>
          <div class="effectiveMobile">
            <div class="contentTitle">
              <div class="label"></div>
              <div class="value">转发手机端用户方法</div>
              <div class="label"></div>
            </div>
            <div class="forwardingMobile">
              <div>点击发送给好友，对方输入访问密码</div>
              <div>即可查阅您的报告。</div>
            </div>
          </div>
          <!-- <button class="sendButton" @click="wxSDK">发送给好友</button> -->
          <div class="shareBox">
            <div  @click="wxSDK">
              <img src="../../assets/wx.png" alt />
              <p>微信好友</p>
            </div>
            <div @click="generateQrCode">
              <img src="../../assets/qr.png" alt />
              <p>生成二维码</p>
            </div>
          </div>
        </div>
        <div class="forwardingFooter">
          <div class="password">访问密码：{{forwardingData.code}}</div>
          <!-- <div class="operationPrompt">温馨提示:转发报告会自动进行脱敏处理</div> -->
        </div>
      </div>
      <!-- <div v-if="noreport" class="white_title">暂无报告</div> -->
    </div>
    <div class="montmorillonite" @click="Montmorillonite" v-if="montmorillonite">
      <img class="arrowDirection" src="../../assets/guide.png" alt />
      <div class="forwardPrompt">
        点击右上角
        <img src="../../assets/threePoints.png" alt />
      </div>
      <div class="forwardPromptTwo">将它转发给指定的朋友</div>
    </div>
     <van-dialog
        v-model="showQrDialog"
        :show-confirm-button="false"
        close-on-click-overlay
        class="qr-dialog"
      >
        <div class="qr-content">
          <div class="qr-title">长按或截屏保存二维码</div>
          <div ref="qrCodeRef" class="qr-code"></div>
          <div class="qr-tip">请长按或截屏二维码图片保存到手机相册</div>
        </div>
      </van-dialog>
  </div>
 
</template>
<script>
import wx from 'weixin-js-sdk'
import axios from 'axios'
import Storage from '@/tools/storage'
import { makeReportLink, getReportInfo } from '@/api/report'
import Vue from 'vue'
import { Notify } from 'vant'
import { link } from 'fs'
import { Toast } from 'vant'
import QRCode from 'qrcodejs2'
export default {
  name: 'forwardingReport',
  data() {
    return {
      examReport: true,
      montmorillonite: false,
      forwardingData: {},
      value: 3,
      option1: [
        { text: '1天', value: 1 },
        { text: '3天', value: 3 },
        { text: '7天', value: 7 }
      ],
      login: '../../assets/login.png',
      report: false,
      noreport: false,
      message: ' \n 本服务由公众号：数字影像云提供',
      encryptResult: [],
      anonymousResult: [],
      waterMartResult: [],
      isEncrypt: 0,
      isAnonymous: 0,
      isWaterMark: 0,
      // isAnonymous （0不匿名 1匿名）
      // isEncrypt （0不加密   1加密）
      reportInfoData: [],
       showQrDialog: false,
      qrCodeInstance: null
    }
  },
  watch: {
    // 监听弹窗显示状态，显示时生成二维码
    showQrDialog(newVal) {
      if (newVal) {
        setTimeout(() => {
          this.generateQrCode()
        }, 1000);
      }
    }
  },
  methods: {
    /* 判断是否可以转发 */
    initial() {
      // let examId = JSON.parse(Storage.get('reportInfo'))[0].exam_id
      let examId = JSON.parse(Storage.get('reportInfo'))
      getReportInfo({
        exam_id: examId.length ? examId[0].exam_id : Storage.get('examId')
      }).then(res => {
        if (res.length) {
          if (res[0].exam_status == 9 || res[0].report_status == 9) {
            this.report = true
            this.noreport = false
          }
        } else {
          this.report = false
          this.noreport = true
        }
      })
    },
    onBack() {
      // this.$router.push({ path: '/filmQuery' })
      this.$router.go(-1)
    },
    toReport() {
      // this.$router.push({ path: '/reportInfo/report' })
      let url = window.location.href;
      let hostname = url.split('/#/')
      if(Storage.get("reportParams")){
        if(url.indexOf("service=1") != -1) {
          window.location.href = hostname[0]+'/#/reportInfo/reportStemp?'+ Storage.get("reportParams")
        }else {
          window.location.href = hostname[0]+'/#/reportInfo/report?'+ Storage.get("reportParams")
        }
      }else{
        this.$router.push({ path: "/reportInfo/report"})
      }
    },
    toPortrait() {
      // this.$router.push({ path: '/reportInfo/portrait' })
      let url = window.location.href;
      let hostname = url.split('/#/')
      if(Storage.get("reportParams")){
        window.location.href = hostname[0]+'/#/reportInfo/portrait?'+ Storage.get("reportParams")
      }else{
        this.$router.push({ path: "/reportInfo/portrait"})
      }
    },
    toAttachment() {
      // this.$router.push({ path: "/reportInfo/attachment" });
      let url = window.location.href;
      let hostname = url.split('/#/')
      if(Storage.get("reportParams")){
        window.location.href = hostname[0]+'/#/reportInfo/attachment?'+ Storage.get("reportParams")
      }else{
        this.$router.push({ path: "/reportInfo/attachment"})
      }
    },
    Montmorillonite() {
      this.montmorillonite = false
    },
    eventEncryptChange(e) {
      if(e.length) {
        this.isEncrypt = 1
      }else {
        this.isEncrypt = 0
      }
    },
    eventAnonymousChange(e) {
      if(e.length) {
        this.isAnonymous = 1
      }else {
        this.isAnonymous = 0
      }
    },
    eventWaterMartChange(e) {
      if(e.length) {
        this.isWaterMark = 1
      }else {
        this.isWaterMark = 0
      }
    },
    anonymizeNameInUrl(url, anonymizedPart = '**') {  
      const nameParamRegex = /&?name=([^&]*)/;  
      const match = url.match(nameParamRegex);  
      if (match) {  
        const originalName = decodeURIComponent(match[1]);  
        const anonymizedName = originalName.charAt(0) + anonymizedPart;  
        const anonymizedUrl = url.replace(nameParamRegex, `&name=${encodeURIComponent(anonymizedName)}`);  
        // return anonymizedUrl.replace('&name=', 'name=');  
        return anonymizedUrl
      }  
      return url;   
    },
    toCopy() {
      let Url2 = encodeURI(this.forwardingData.url)
      let oInput = document.createElement('input') //创建一个隐藏input（重要！）
      oInput.value = this.getUrl(Url2)
      this.$refs.body.appendChild(oInput)
      // document.body.appendChild(oInput)
      oInput.select() // 选择对象
      let judge = document.execCommand('Copy') // 执行浏览器复制命令
      oInput.className = 'oInput'
      oInput.style.display = 'none'
      console.log(oInput.value)
      if (judge == true) {
        Notify({ type: 'success', message: '复制成功,请选择联系人去粘贴吧' })
      } else {
        alert('复制失败，请您手动复制')
      }
    },
    getUrl(Url2){
      if(this.isAnonymous && this.isEncrypt){
        return this.anonymizeNameInUrl(Url2) + '&isAnonymous=' + this.isAnonymous + '&isWaterMark=' + this.isWaterMark + '&isEncrypt=' + this.isEncrypt + ' ' + '密码：' + this.forwardingData.code //赋值
      }else if(!this.isAnonymous && !this.isEncrypt){
        return Url2 + '&isAnonymous=' + this.isAnonymous + '&isWaterMark=' + this.isWaterMark + '&isEncrypt=' + this.isEncrypt + ' '//赋值
      }else if(this.isAnonymous && !this.isEncrypt){
        return this.anonymizeNameInUrl(Url2) + '&isAnonymous=' + this.isAnonymous + '&isWaterMark=' + this.isWaterMark + '&isEncrypt=' + this.isEncrypt + ' '
      }else if(!this.isAnonymous && this.isEncrypt){
        return Url2 + '&isAnonymous=' + this.isAnonymous + '&isWaterMark=' + this.isWaterMark + '&isEncrypt=' + this.isEncrypt + ' ' + '密码：' + this.forwardingData.code //赋值
      }
    },
    generateQrCode() {
      let Url2 = encodeURI(this.forwardingData.url);
      const targetUrl = this.getUrl(Url2);
      
      // 显示弹窗
      this.showQrDialog = true;
      
      // 确保DOM更新完成
      this.$nextTick(() => {
        const qrContainer = this.$refs.qrCodeRef;
        
        // 清除旧二维码
        if (this.qrCodeInstance) {
          qrContainer.innerHTML = '';
          this.qrCodeInstance = null;
        }
        
        try {
          // 生成新二维码
          this.qrCodeInstance = new QRCode(qrContainer, {
            text: targetUrl,
            width: 250,
            height: 250,
            colorDark: '#000000',
            colorLight: '#ffffff',
            correctLevel: QRCode.CorrectLevel.H
          });
          
          Toast.clear();
        } catch (err) {
          console.error('生成二维码失败:', err);
          Toast.fail('生成二维码失败');
          this.showQrDialog = false;
        }
      });
    },

// 下载二维码图片
downloadQrCode(canvas) {
  // 将canvas转换为图片URL
  const qrUrl = canvas.toDataURL('image/png');
  
  // 创建下载链接
  const a = document.createElement('a');
  a.download = `${this.reportInfoData[0].name}_检查报告二维码.png`;
  a.href = qrUrl;
  document.body.appendChild(a);
  a.click();
  
  // 清理
  setTimeout(() => {
    document.body.removeChild(a);
    Toast.success('二维码已下载');
  }, 100);
},
    wxSDK() {
      this.montmorillonite = true
      this.toCopy()
      const that = this
      axios
        .post('https://wechat.pacsonline.cn/wx_patient/api/getJsSdkConfig')
        .then(res => {
          const appId = res.data.appId
          const timestamp = res.data.timestamp
          const nonceStr = res.data.nonceStr
          const signature = res.data.signature
          // 利用重定向解决ios vue hash模式下微信分享后打开首页而不是当前分享页面问题
          let shareLink =
            'https://wc4.pacsonline.cn/#/reportInfo/report?id=' +
            that.forwardingData.id + '&short=1' + '&name=' +
            JSON.parse(Storage.get('reportInfo'))[0].name
          shareLink =
            window.location.href.split('#')[0] +
            'redirect.html?shareRedirect=' +
            encodeURIComponent(this.getUrl(shareLink))
          let imgUrl = 'https://wc4.pacsonline.cn/share.png'
          wx.config({
            debug: false,
            appId: appId,
            timestamp: timestamp,
            nonceStr: nonceStr,
            signature: signature,
            jsApiList: ['onMenuShareAppMessage']
          })
          // updateAppMessageShareData
          wx.ready(function () {
            wx.onMenuShareAppMessage({
              title:
                JSON.parse(Storage.get('reportInfo'))[0].name + '的检查报告', // 分享描述
              desc: '密码:' + that.forwardingData.code + that.message,
              link: shareLink,
              imgUrl: imgUrl, // 分享图标
              type: 'link', // 分享类型,music、video或link，不填默认为link
              dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
              success: function (res) {
                alert('成功了')
                that.montmorillonite = false
                // 用户点击了分享后执行的回调函数
              },
              cancel: function () {
                alert('取消分享')
                // 用户取消分享后执行的回调函数
              }
            })
          })
          wx.error(function (res) {
            alert('进wx.error')
          })
        })
    },
    async getMakeReportLink() {
      // let examId = JSON.parse(Storage.get('reportInfo'))[0].exam_id
      let params
      if (Storage.get('code') == 2) {
        params = {
          url: 'https://wc4.pacsonline.cn/#/reportInfo/portrait',
          overdueTime: this.value,
          examId: this.reportInfoData.length ? this.reportInfoData[0].exam_id : Storage.get('examId'),
          phone: Storage.get('phone'),
          report: 2,
          // study_id: JSON.parse(Storage.get('reportInfo'))[0].study_id
          study_id: this.reportInfoData.length ? this.reportInfoData[0].study_id : Storage.get('studyId'),
        }
      } else {
        params = {
          url: 'https://wc4.pacsonline.cn/#/reportInfo/report',
          overdueTime: this.value,
          examId: this.reportInfoData.length ? this.reportInfoData[0].exam_id : Storage.get('examId'),
          phone: Storage.get('phone'),
          report: 1,
          study_id: this.reportInfoData.length ? this.reportInfoData[0].study_id : Storage.get('studyId'),
        }
      }
      let res = await makeReportLink(params)
      if (res) {
        console.log(res)
        this.forwardingData = res
      }
    }
  },
  mounted() {
    // this.initial()
    this.getMakeReportLink()
  },
  created() {
    this.reportInfoData = JSON.parse(Storage.get('reportInfo'))
    this.reportInfoData[0].institution_id === '06300007'? this.value = 1 : this.value = 3
    if (Storage.get('code') == 2 && Storage.get('examStatus') == 1) {
      this.examReport = false
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../style/reportInfo/forwarding.css';
.van-cell__title {
  padding-left: 0;
}
.white_title {
  height: 100vh;
  line-height: 100vh;
  font-size: 20px;
}

.qr-dialog {
  width: 80%;
  max-width: 300px;
  border-radius: 12px;
  overflow: hidden;
}

.qr-content {
  padding: 20px;
  text-align: center;
}

.qr-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #333;
}

.qr-code {
  margin: 0 auto;
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.qr-code canvas {
  width: 50px!important;
}

.qr-tip {
  margin-top: 15px;
  font-size: 14px;
  color: #666;
}
</style>


